<div class="warning-snackbar-container">
	<div class="warning-snackbar-icon">
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 3.5C7.30521 3.5 3.5 7.30521 3.5 12C3.5 16.6938 7.30527 20.5 12 20.5C16.6938 20.5 20.5 16.6938 20.5 12C20.5 7.30527 16.6938 3.5 12 3.5ZM2 12C2 6.47679 6.47679 2 12 2C17.5222 2 22 6.47673 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12Z"
				fill="#D37B4A"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M11.9941 7.45312C12.4084 7.45312 12.7441 7.78891 12.7441 8.20312V12.6221C12.7441 13.0363 12.4084 13.3721 11.9941 13.3721C11.5799 13.3721 11.2441 13.0363 11.2441 12.6221V8.20312C11.2441 7.78891 11.5799 7.45312 11.9941 7.45312Z"
				fill="#D37B4A"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.9941 15.7969C10.9941 15.2446 11.4419 14.7969 11.9941 14.7969H12.0041C12.5564 14.7969 13.0041 15.2446 13.0041 15.7969C13.0041 16.3492 12.5564 16.7969 12.0041 16.7969H11.9941C11.4419 16.7969 10.9941 16.3492 10.9941 15.7969Z"
				fill="#459CBA"
			/>
		</svg>
	</div>
	<div class="warning-snackbar-body">
		<h3 class="warning-snackbar-title" data-automation-id="addUser-DuplicateEmailToastTitle">Duplicate Email</h3>
		<p class="warning-snackbar-description" data-automation-id="addUser-DuplicateEmailToastMessage">
			This email is already registered. Each user must have a unique email address.
		</p>
	</div>
</div>
